import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorResponse } from 'src/app/models/error.model';
import { Zona } from 'src/app/models/zona.model';
import { ZonasService } from 'src/app/services/zonas.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-edit-zona',
    templateUrl: './edit-zona.component.html',
    styleUrls: ['./edit-zona.component.scss']
})
export class EditZonaComponent implements OnInit {

    zona?: Zona;

    form = new UntypedFormGroup({
        nombre: new UntypedFormControl('', [Validators.required]),
        aclaracion: new UntypedFormControl(''),
        activo: new UntypedFormControl(true, [Validators.required])
    });

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private zonasService: ZonasService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params?.id) {
                this.zonasService.getZonaById(params.id).subscribe({
                    next: zona => {
                        this.zona = zona;
                        this.form.setValue({
                            nombre: zona.nombre,
                            aclaracion: zona.aclaracion ?? '',
                            activo: zona.activo
                        });
                    },
                    error: (error: ErrorResponse) => this.utilsService.alert('Error al obtener la zona', error.error?.descripcion)
                });
            }
        });
    }

    save() {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }
        const payload: Zona = {
            nombre: this.form.value.nombre,
            aclaracion: this.form.value.aclaracion || null,
            activo: this.form.value.activo
        };
        if (this.zona) {
            this.zonasService.updateZona({ ...payload, id: this.zona.id }).subscribe({
                next: () => {
                    this.utilsService.alert('Zona actualizada', `La zona "${payload.nombre}" fue actualizada correctamente.`);
                    this.router.navigate(['configuracion', 'calculadora', 'zonas']);
                },
                error: (error: ErrorResponse) => this.utilsService.alert('Error al actualizar la zona', error.error?.descripcion)
            });
        } else {
            this.zonasService.createZona(payload).subscribe({
                next: () => {
                    this.utilsService.alert('Zona creada', `La zona "${payload.nombre}" fue creada correctamente.`);
                    this.router.navigate(['configuracion', 'calculadora', 'zonas']);
                },
                error: (error: ErrorResponse) => this.utilsService.alert('Error al crear la zona', error.error?.descripcion)
            });
        }
    }

    cancel() {
        this.router.navigate(['configuracion', 'calculadora', 'zonas']);
    }
}
